import { useState } from 'react';

const TARIFAS_REFERENCIA = [
  { label: 'Básica',    desde: 8000,  hasta: 12000, desc: 'Árbitros con menos experiencia' },
  { label: 'Estándar', desde: 12000, hasta: 16000, desc: 'La más común en la zona'         },
  { label: 'Premium',  desde: 16000, hasta: 22000, desc: 'Árbitros con certificación'      },
];

export default function StepTarifaArbitro({ datos, onNext, onBack }) {
  const [tarifa,      setTarifa]      = useState(datos.tarifa      || '');
  const [certificado, setCertificado] = useState(datos.certificado || false);
  const [federado,    setFederado]    = useState(datos.federado    || false);
  const [error,       setError]       = useState('');

  const handleNext = () => {
    if (!tarifa || Number(tarifa) < 5000) {
      setError('Ingresa una tarifa válida (mínimo $5.000)');
      return;
    }
    onNext({ tarifa: Number(tarifa), certificado, federado });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Tarifa y certificaciones</h2>
      <p style={styles.sub}>
        Define tu tarifa por partido. Los equipos la verán
        antes de contratarte.
      </p>

      {/* Referencia de tarifas */}
      <div style={styles.referenciaWrap}>
        <div style={styles.referenciaTitle}>Tarifas de referencia en tu zona</div>
        <div style={styles.referenciaGrid}>
          {TARIFAS_REFERENCIA.map(({ label, desde, hasta, desc }) => (
            <div
              key={label}
              style={styles.referenciaCard}
              onClick={() => setTarifa(String(Math.round((desde + hasta) / 2)))}
            >
              <div style={styles.referenciaLabel}>{label}</div>
              <div style={styles.referenciaRango}>
                ${desde.toLocaleString('es-CL')} – ${hasta.toLocaleString('es-CL')}
              </div>
              <div style={styles.referenciaDesc}>{desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tarifa personalizada */}
      <div style={styles.campo}>
        <label style={styles.label}>Tu tarifa por partido ($)</label>
        <input
          type="number"
          value={tarifa}
          onChange={e => { setTarifa(e.target.value); setError(''); }}
          placeholder="Ej: 15000"
          style={{
            ...styles.input,
            borderColor: error ? '#EF4444' : '#E8ECF4',
          }}
          min="5000"
        />
        {tarifa && Number(tarifa) >= 5000 && (
          <div style={styles.tarifaPreview}>
            Tu tarifa: <strong>${Number(tarifa).toLocaleString('es-CL')}</strong> por partido
          </div>
        )}
        {error && <span style={styles.error}>{error}</span>}
      </div>

      {/* Certificaciones */}
      <div style={styles.campo}>
        <label style={styles.label}>Certificaciones</label>
        <div style={styles.certList}>
          {[
            { key: 'certificado', label: 'Árbitro certificado por asociación deportiva', val: certificado, set: setCertificado },
            { key: 'federado',    label: 'Árbitro federado',                              val: federado,    set: setFederado    },
          ].map(({ key, label, val, set }) => (
            <div
              key={key}
              onClick={() => set(!val)}
              style={{
                ...styles.certCard,
                border: `2px solid ${val ? '#16A34A' : '#E8ECF4'}`,
                background: val ? '#F0FDF4' : 'white',
              }}
            >
              <div style={{
                ...styles.certCheck,
                background: val ? '#16A34A' : '#E8ECF4',
              }}>
                {val ? '✓' : ''}
              </div>
              <span style={{
                fontSize: 13, fontWeight: 500,
                color: val ? '#16A34A' : '#4A5568',
                fontFamily: "'Barlow', sans-serif",
              }}>
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  referenciaWrap: {
    background: '#F4F6FA', borderRadius: 12,
    padding: '14px 16px', marginBottom: 20,
  },
  referenciaTitle: {
    fontSize: 11, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 10,
  },
  referenciaGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8,
  },
  referenciaCard: {
    background: 'white', borderRadius: 10,
    padding: '10px 12px', cursor: 'pointer',
    border: '1px solid #E8ECF4',
    transition: 'all 0.12s',
  },
  referenciaLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700, color: '#141922', marginBottom: 3,
  },
  referenciaRango: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#1A6BFF', marginBottom: 3,
  },
  referenciaDesc: {
    fontSize: 10, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  campo: { marginBottom: 20 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  tarifaPreview: {
    fontSize: 13, color: '#16A34A',
    fontFamily: "'Barlow', sans-serif",
    marginTop: 6,
  },
  error: {
    display: 'block', fontSize: 11,
    color: '#EF4444', marginTop: 4,
    fontFamily: "'Barlow', sans-serif",
  },
  certList: { display: 'flex', flexDirection: 'column', gap: 8 },
  certCard: {
    display: 'flex', alignItems: 'center', gap: 12,
    borderRadius: 10, padding: '12px 14px',
    cursor: 'pointer', transition: 'all 0.12s',
  },
  certCheck: {
    width: 22, height: 22, borderRadius: '50%',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 11,
    fontWeight: 700, color: 'white', flexShrink: 0,
    transition: 'background 0.12s',
  },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
};